<script setup lang="ts">
import {SearchBarAutoCompleteItem} from "@/auto-complete-searchbar/interfaces/ISearchBarAutoComplete";
import {X} from "@lucide/vue";
import sections from "@/core/factories/search-bar/AutoCompleteConfig";

const emits = defineEmits<{
    (e: 'remove', item: SearchBarAutoCompleteItem): void;
}>();

const {item} = defineProps<{
    item: SearchBarAutoCompleteItem
}>();
</script>

<template>
  <div
    class="flex items-center gap-2 p-2 rounded-md bg-gray-100 cursor-pointer transition-colors shrink-0"
    :style="{
      backgroundColor: sections[item.type].color,
    }"
    @click="emits('remove', item)"
  >
    <div class="flex-1">
      <div class="text-xs font-medium line-clamp-1">
        {{ item.name }}
      </div>
    </div>
    <X class="w-3 h-3" />
  </div>
</template>
